import { useWishlist } from '../../context/WishlistContext';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart, Star } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const { isInWishlist, toggleWishlist } = useWishlist();
const isWishlisted = isInWishlist(product.id);
  const { addToCart, openCart } = useCart();

  const handleQuickAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product, 1, product.sizes[0], product.colors[0] || { name: 'Default', hex: '#000000' });
    openCart();
  };

  const handleWishlist = (e) => {
  e.preventDefault();
  e.stopPropagation();
  toggleWishlist(product);
};

  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(product.rating);
    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(<Star key={i} className="product-card-star" fill="#F59E0B" />);
      } else {
        stars.push(<Star key={i} className="product-card-star empty" />);
      }
    }
    return stars;
  };

  const discountPercentage = product.salePrice ? Math.round(((product.price - product.salePrice) / product.price) * 100) : 0;
  const badgeClass = product.badge === 'NEW' ? 'new' : product.badge === 'BEST SELLER' ? 'bestseller' : '';

  return (
    <Link to={`/product/${product.id}`} className="product-card">
      <div className="product-card-image-container">
        <img src={product.image} alt={product.name} className="product-card-image" loading="lazy" />
        {product.badge && <span className={`product-card-badge ${badgeClass}`}>{product.badge}</span>}
        <button className={`product-card-wishlist ${isWishlisted ? 'active' : ''}`} onClick={handleWishlist}>
          <Heart size={18} fill={isWishlisted ? '#E11D48' : 'transparent'} color={isWishlisted ? '#E11D48' : '#0A0A0A'} />
        </button>
        <button type="button" className="product-card-quick-add" onClick={handleQuickAdd}>
          Quick add
        </button>
      </div>
      <div className="product-card-content">
        <p className="product-card-brand">{product.brand}</p>
        <h3 className="product-card-name">{product.name}</h3>
        <div className="product-card-rating">
          <div className="product-card-stars">{renderStars()}</div>
          <span className="product-card-reviews">({product.reviews})</span>
        </div>
        <div className="product-card-pricing">
          <span className="product-card-price">${(product.salePrice || product.price).toFixed(2)}</span>
          {product.salePrice && (
            <>
              <span className="product-card-original-price">${product.price.toFixed(2)}</span>
              <span className="product-card-discount">{discountPercentage}% OFF</span>
            </>
          )}
        </div>
        {product.colors.length > 0 && (
          <div className="product-card-colors">
            {product.colors.slice(0, 4).map((color) => (
              <span key={color.name} className="product-card-color" style={{ backgroundColor: color.hex }} title={color.name} />
            ))}
          </div>
        )}
      </div>
    </Link>
  );
};

export default ProductCard;
